
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/assurance-of-iyimakina",
      function () {
        return require("private-next-pages/content/buying/assurance-of-iyimakina.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/assurance-of-iyimakina"])
      });
    }
  